interface throwsList {
    group: number;
    imgUrl: string;
    throwName: string;
    description: string;
    videoUrl: string;
}

const judoThrows: throwsList[] = [
    {
        group: 1,
        imgUrl: "/throws/1.jpg",
        throwName: "Deashi Harai",
        description: "Deashi Harai is a foot sweep technique used to off-balance an opponent by sweeping their foot out from under them.",
        videoUrl: "https://www.youtube.com/embed/I25HN3DE8hs"
    },
    {
        group: 1,
        imgUrl: "/throws/2.jpg",
        throwName: "Hiza Guruma",
        description: "Hiza Guruma is a knee wheel technique where the opponent's knee is used to off-balance them, often leading to a throw.",
        videoUrl: "https://www.youtube.com/embed/VDsiBURKj-s"
    },
    {
        group: 1,
        imgUrl: "/throws/3.jpg",
        throwName: "Sasae Tsurikomi Ashi",
        description: "Sasae Tsurikomi Ashi is a supporting foot technique that involves blocking an opponent's foot to off-balance them.",
        videoUrl: "https://www.youtube.com/embed/nrmtaMeVQd4"
    },
    {
        group: 1,
        imgUrl: "/throws/4.jpg",
        throwName: "Uki Goshi",
        description: "Uki Goshi is a floating hip technique where the opponent is lifted and thrown over the hip.",
        videoUrl: "https://www.youtube.com/embed/3Fklhya3iu4"
    },
    {
        group: 1,
        imgUrl: "/throws/5.jpg",
        throwName: "Osoto Gari",
        description: "Osoto Gari is a major outer reap technique used to throw an opponent by reaping their leg out from under them.",
        videoUrl: "https://www.youtube.com/embed/gus3kezcBcM"
    },
    {
        group: 1,
        imgUrl: "/throws/6.jpg",
        throwName: "O Goshi",
        description: "O Goshi is a major hip throw where the opponent is lifted and thrown over the hip.",
        videoUrl: "https://www.youtube.com/embed/jn0WObPwTqg"
    },
    {
        group: 1,
        imgUrl: "/throws/7.jpg",
        throwName: "Ouchi Gari",
        description: "Ouchi Gari is a major inner reap technique used to throw an opponent by reaping their leg from the inside.",
        videoUrl: "https://www.youtube.com/embed/6OxoWzpwezo"
    },
    {
        group: 1,
        imgUrl: "/throws/8.jpg",
        throwName: "Seoi Nage",
        description: "Seoi Nage is a shoulder throw where the opponent is thrown over the shoulder.",
        videoUrl: "https://www.youtube.com/embed/dHrSqRMC04Q"
    },
    {
        group: 2,
        imgUrl: "/throws/9.jpg",
        throwName: "Kosoto Gari",
        description: "Kosoto Gari is a minor outer reap technique used to throw an opponent by reaping their leg out from under them.",
        videoUrl: "https://www.youtube.com/embed/FtLazfLYL6k"
    },
    {
        group: 2,
        imgUrl: "/throws/10.jpg",
        throwName: "Kouchi Gari",
        description: "Kouchi Gari is a minor inner reap technique used to throw an opponent by reaping their leg from the inside.",
        videoUrl: "https://www.youtube.com/embed/j9DnkH-2tGg"
    },
    {
        group: 2,
        imgUrl: "/throws/11.jpg",
        throwName: "Koshi Guruma",
        description: "Koshi Guruma is a hip wheel technique where the opponent is thrown over the hip.",
        videoUrl: "https://www.youtube.com/embed/vharlgzgJlA"
    },
    {
        group: 2,
        imgUrl: "/throws/12.jpg",
        throwName: "Tsurikomi Goshi",
        description: "Tsurikomi Goshi is a lifting hip technique where the opponent is lifted and thrown over the hip.",
        videoUrl: "https://www.youtube.com/embed/73bThxi0q0s"
    },
    {
        group: 2,
        imgUrl: "/throws/13.jpg",
        throwName: "Okuri Ashi Harai",
        description: "Okuri Ashi Harai is a sliding foot sweep technique used to off-balance an opponent by sweeping their foot out from under them.",
        videoUrl: "https://www.youtube.com/embed/4ug0u9a_xyE"
    },
    {
        group: 2,
        imgUrl: "/throws/14.jpg",
        throwName: "Tai Otoshi",
        description: "Tai Otoshi is a body drop technique where the opponent is thrown by dropping the body and using leverage.",
        videoUrl: "https://www.youtube.com/embed/bweEltFImMA"
    },
    {
        group: 2,
        imgUrl: "/throws/15.jpg",
        throwName: "Harai Goshi",
        description: "Harai Goshi is a sweeping hip throw where the opponent is thrown by sweeping their leg out from under them.",
        videoUrl: "https://www.youtube.com/embed/WbK9COV-GpY"
    },
    {
        group: 2,
        imgUrl: "/throws/16.jpg",
        throwName: "Uchi Mata",
        description: "Uchi Mata is an inner thigh throw where the opponent is thrown by lifting their leg and using leverage.",
        videoUrl: "https://www.youtube.com/embed/QQjMkHGU_Ic"
    },
    {
        group: 3,
        imgUrl: "/throws/17.jpg",
        throwName: "Kosoto Gake",
        description: "Kosoto Gake is a minor outer hook technique used to throw an opponent by hooking their leg from the outside.",
        videoUrl: "https://www.youtube.com/embed/QpE9TREP9ys"
    },
    {
        group: 3,
        imgUrl: "/throws/18.jpg",
        throwName: "Tsuri Goshi",
        description: "Tsuri Goshi is a lifting hip technique where the opponent is lifted and thrown over the hip.",
        videoUrl: "https://www.youtube.com/embed/lV_HUZ9m1fQ"
    },
    {
        group: 3,
        imgUrl: "/throws/19.jpg",
        throwName: "Yoko Otoshi",
        description: "Yoko Otoshi is a side drop technique where the opponent is thrown by dropping to the side and using leverage.",
        videoUrl: "https://www.youtube.com/embed/PELgzOt-Dus"
    },
    {
        group: 3,
        imgUrl: "/throws/20.jpg",
        throwName: "Ashi Guruma",
        description: "Ashi Guruma is a leg wheel technique where the opponent's leg is used to off-balance them, often leading to a throw.",
        videoUrl: "https://www.youtube.com/embed/0cCsllLrClY"
    },
    {
        group: 3,
        imgUrl: "/throws/21.jpg",
        throwName: "Hane Goshi",
        description: "Hane Goshi is a springing hip throw where the opponent is thrown by using a springing motion with the hips.",
        videoUrl: "https://www.youtube.com/embed/TTLgAT_uEis"
    },
    {
        group: 3,
        imgUrl: "/throws/22.jpg",
        throwName: "Harai Tsurikomi Ashi",
        description: "Harai Tsurikomi Ashi is a sweeping supporting foot technique that involves blocking an opponent's foot to off-balance them.",
        videoUrl: "https://www.youtube.com/embed/vjwerq6UZIs"
    },
    {
        group: 3,
        imgUrl: "/throws/23.jpg",
        throwName: "Tomoe Nage",
        description: "Tomoe Nage is a circular throw where the opponent is thrown by using a circular motion with the body.",
        videoUrl: "https://www.youtube.com/embed/tOIbQ2cXRHU"
    },
    {
        group: 3,
        imgUrl: "/throws/24.jpg",
        throwName: "Kata Guruma",
        description: "Kata Guruma is a shoulder wheel technique where the opponent is thrown over the shoulder in a wheel-like motion.",
        videoUrl: "https://www.youtube.com/embed/yD09HBiPgEU"
    },
    {
        group: 4,
        imgUrl: "/throws/25.jpg",
        throwName: "Sumi Gaeshi",
        description: "Sumi Gaeshi is a corner throw where the opponent is thrown by using a cornering motion with the body.",
        videoUrl: "https://www.youtube.com/embed/-xQm8PV155s"
    },
    {
        group: 4,
        imgUrl: "/throws/26.jpg",
        throwName: "Tani Otoshi",
        description: "Tani Otoshi is a valley drop technique where the opponent is thrown by dropping into a valley-like motion.",
        videoUrl: "https://www.youtube.com/embed/Rfi6zRDQQRI"
    },
    {
        group: 4,
        imgUrl: "/throws/27.jpg",
        throwName: "Hane Makikomi",
        description: "Hane Makikomi is a springing wrap-around throw where the opponent is thrown by wrapping around them in a springing motion.",
        videoUrl: "https://www.youtube.com/embed/Jtkr4lcGcbA"
    },
    {
        group: 4,
        imgUrl: "/throws/28.jpg",
        throwName: "Sukui Nage",
        description: "Sukui Nage is a scoop throw where the opponent is scooped up and thrown.",
        videoUrl: "https://www.youtube.com/embed/LfBesVQaHXU"
    },
    {
        group: 4,
        imgUrl: "/throws/29.jpg",
        throwName: "Utsuri Goshi",
        description: "Utsuri Goshi is a shifting hip throw where the opponent is thrown by shifting the hips.",
        videoUrl: "https://www.youtube.com/embed/39aWDO7e0vM"
    },
    {
        group: 4,
        imgUrl: "/throws/30.jpg",
        throwName: "O Guruma",
        description: "O Guruma is a major wheel throw where the opponent is thrown in a wheel-like motion.",
        videoUrl: "https://www.youtube.com/embed/jNf08NFlaUg"
    },
    {
        group: 4,
        imgUrl: "/throws/31.jpg",
        throwName: "Soto Makikomi",
        description: "Soto Makikomi is an outer wrap-around throw where the opponent is thrown by wrapping around them from the outside.",
        videoUrl: "https://www.youtube.com/embed/GE8ITtd-b8Q"
    },
    {
        group: 4,
        imgUrl: "/throws/32.jpg",
        throwName: "Uki-otoshi",
        description: "Uki-otoshi is a floating drop technique where the opponent is thrown by dropping them in a floating motion.",
        videoUrl: "https://www.youtube.com/embed/X2Y1E0xjE3Y"
    },
    {
        group: 5,
        imgUrl: "/throws/33.jpg",
        throwName: "Osoto Guruma",
        description: "Osoto Guruma is a major outer wheel throw where the opponent is thrown in a wheel-like motion using the outer leg.",
        videoUrl: "https://www.youtube.com/embed/SnG36ufXnk0"
    },
    {
        group: 5,
        imgUrl: "/throws/34.jpg",
        throwName: "Uki Waza",
        description: "Uki Waza is a floating technique where the opponent is thrown by lifting them and using a floating motion.",
        videoUrl: "https://www.youtube.com/embed/Ue04ZUBSXoM"
    },
    {
        group: 5,
        imgUrl: "/throws/35.jpg",
        throwName: "Yoko Wakare",
        description: "Yoko Wakare is a side separation technique where the opponent is thrown by separating them to the side.",
        videoUrl: "https://www.youtube.com/embed/hqM5LL5YkNA"
    },
    {
        group: 5,
        imgUrl: "/throws/36.jpg",
        throwName: "Yoko Guruma",
        description: "Yoko Guruma is a side wheel throw where the opponent is thrown in a wheel-like motion to the side.",
        videoUrl: "https://www.youtube.com/embed/eLcaT8HATRA"
    },
    {
        group: 5,
        imgUrl: "/throws/37.jpg",
        throwName: "Ushiro Goshi",
        description: "Ushiro Goshi is a rear hip throw where the opponent is thrown over the hip from the rear.",
        videoUrl: "https://www.youtube.com/embed/r31DHx-o7nc"
    },
    {
        group: 5,
        imgUrl: "/throws/38.jpg",
        throwName: "Ura Nage",
        description: "Ura Nage is a rear throw where the opponent is thrown from the rear in a lifting motion.",
        videoUrl: "https://www.youtube.com/embed/6Ag8Gl76BQs"
    },
    {
        group: 5,
        imgUrl: "/throws/39.jpg",
        throwName: "Sumi Otoshi",
        description: "Sumi Otoshi is a corner drop technique where the opponent is thrown by dropping them into a corner-like motion.",
        videoUrl: "https://www.youtube.com/embed/uTYru2xGYcM"
    },
    {
        group: 5,
        imgUrl: "/throws/40.jpg",
        throwName: "Yoko Gake",
        description: "Yoko Gake is a side hook technique where the opponent is thrown by hooking their leg from the side.",
        videoUrl: "https://www.youtube.com/embed/ZjIL-u46po4"
    },
];

export default judoThrows;